import { render, staticRenderFns } from "./FindingDetails.vue?vue&type=template&id=87f7680e"
import script from "./FindingDetails.vue?vue&type=script&lang=js"
export * from "./FindingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports